module.exports = __webpack_public_path__ + "static/media/anthropic_logoe.6faab539.png";